export const MeetTheStaff = () => {
    return (
        <>
            <section className="pizzabg pb-1 pt-4">
                <div className="container">
                    <div className="row text-center mb-5">
                        <div className="col-md-8 offset-md-2">
                            <h1 className="text-success satisfy-regular">
                                Meet the staff
                            </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <div className="d-flex gap-3">
                                <div className="number">
                                    <span className="bg-danger py-2 px-4 fs-3 rounded-circle">
                                        C
                                    </span>
                                </div>
                                <div>
                                    <h3 className="fs-3 text-success satisfy-regular">
                                        Brian - Chef
                                    </h3>
                                    <p>
                                        In Brian's own words he's a 'simple
                                        man', which basically translates to
                                        instrinsically unlikeable. He loves
                                        talking politics and freely admits he
                                        doesn't really like people. Any
                                        interaction with Brian is bound to have
                                        a negative impact on your day.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="d-flex gap-3">
                                <div className="number">
                                    <span className="bg-danger py-2 px-4 fs-3 rounded-circle">
                                        C
                                    </span>
                                </div>
                                <div>
                                    <h3 className="fs-3 text-success satisfy-regular">
                                        Sarah - Chef
                                    </h3>
                                    <p>
                                        Sarah, 41, is perhaps the polar opposite
                                        to Brian. She loves cats, dislikes
                                        pineapple, and is generally very kind
                                        and caring. Dave often fumbles his words
                                        around Sarah for some unknown reason.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="d-flex gap-3">
                                <div className="number">
                                    <span className="bg-danger py-2 px-4 fs-3 rounded-circle">
                                        B
                                    </span>
                                </div>
                                <div>
                                    <h3 className="fs-3 text-success satisfy-regular">
                                        Jeremy - Bartender
                                    </h3>
                                    <p>
                                        Jeremy is 22 and quite an affable chap.
                                        He never needs to be told by management
                                        to smile as he's nearly always happy,
                                        especially if he can regale you with his
                                        'comedic' tales. He loves wine - a lot -
                                        and dislikes rudeness.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="d-flex gap-3">
                                <div className="number">
                                    <span className="bg-danger py-2 px-4 fs-3 rounded-circle">
                                        B
                                    </span>
                                </div>
                                <div>
                                    <h3 className="fs-3 text-success satisfy-regular">
                                        Laura - Bartender
                                    </h3>
                                    <p>
                                        Laura, 24, is often quite short with
                                        people, and as a result, doesn't come
                                        across as the most friendly person in
                                        the world. Weirdly, she gets on well
                                        with Brian, despite the fact she doesn't
                                        like talking about politics. She also
                                        likes Sarah but the blunt behaviour
                                        thing isn't doing her any favours.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="d-flex gap-3">
                                <div className="number">
                                    <span className="bg-danger py-2 px-4 fs-3 rounded-circle">
                                        W
                                    </span>
                                </div>
                                <div>
                                    <h3 className="fs-3 text-success satisfy-regular">
                                        Steve - Waiter
                                    </h3>
                                    <p>
                                        30-year-old Steve is pleasant enough.
                                        He'll often talk about his gaming rig at
                                        home and what game he's currently
                                        playing, whether you want him to or not.
                                        Regardless of how many layers he wears,
                                        he is perpetually cold.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="d-flex gap-3">
                                <div className="number">
                                    <span className="bg-danger py-2 px-4 fs-3 rounded-circle">
                                        W
                                    </span>
                                </div>
                                <div>
                                    <h3 className="fs-3 text-success satisfy-regular">
                                        Dave - Waiter
                                    </h3>
                                    <p>
                                        Dave, please submit your personal
                                        description so we can rewrite it to our
                                        liking.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
